import Tippy from "@tippyjs/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { basic_compass } from "react-icons-kit/linea/basic_compass";
import { basic_smartphone } from "react-icons-kit/linea/basic_smartphone";
import { basic_mail } from "react-icons-kit/linea/basic_mail";
import { basic_world } from "react-icons-kit/linea/basic_world";
import { LazyLoadImage } from "react-lazy-load-image-component";

const OrganizationPledges = ({
  pledgesArray,
  pledgesError,
  orgName,
  orgObj,
  content,
  handleGoBack,
}) => {
  // use t function where ever hard coded text is used
  const { t } = useTranslation();

  // selector btns
  const [step, setStep] = useState("pledges");

  // navigate
  const navigate = useNavigate();

  // handle navigation on card click
  const handleNavigationOnCardClick = (obj) => {
    navigate(`/sites/${orgName}/pledges/${obj.tagNumber}`);
  };

  return (
    <>
      <div className="campaigns-or-contact">
        <button
          type="button"
          onClick={() => setStep("pledges")}
          className={`selector-btns${step === "pledges" ? " active" : ""}`}
        >
          {t("OrganizationDetails.pledges").toUpperCase()}
        </button>
        <button
          type="button"
          onClick={() => setStep("contact")}
          className={`selector-btns${step === "contact" ? " active" : ""}`}
        >
          {t("OrganizationDetails.contact")}
        </button>
      </div>

      {step === "pledges" && (
        <>
          {pledgesError ? (
            <div className="error-msg" style={{ margin: "10px auto" }}>
              {pledgesError}
            </div>
          ) : (
            <>
              {pledgesArray?.length > 0 ? (
                <>
                  <div
                    className="campaign-msg"
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("pledge.select_a_pledge")}
                  </div>

                  <div className="pledges-wrapper">
                    {pledgesArray.map((data, index) => (
                      <div
                        className="pledge-card"
                        key={data.tagNumber}
                        onClick={() => handleNavigationOnCardClick(data)}
                      >
                        <LazyLoadImage
                          src={data.campaignImage}
                          alt={data.campaign}
                          className="pledge-image"
                          effect="blur"
                        />

                        <h3 className="pledge-title">{data.name}</h3>

                        <div className="pledge-content">
                          <div className="data-card-item">
                            <div className="label">
                              {t("pledge.target_amount")}
                            </div>
                            <div className="value">
                              {data.currencySymbol}
                              {data.targetAmount}
                            </div>
                          </div>

                          {data.showProgress && (
                            <div className="data-card-item">
                              <div className="label">
                                {t("pledge.pledged_amount")}
                              </div>
                              <div className="value">
                                {data.currencySymbol}
                                {data.pledgedAmount}
                              </div>
                            </div>
                          )}

                          <div className="data-card-item">
                            <div className="label">
                              {t("pledge.target_count")}
                            </div>
                            <div className="value">{data.targetCount}</div>
                          </div>

                          {data.showProgress && (
                            <Tippy
                              content={`${data.fulfillmentPercentage.toFixed(
                                2
                              )}%`}
                            >
                              <div className="progress-container">
                                <div
                                  className="fulfill-progress"
                                  style={{
                                    width: `${data.fulfillmentPercentage}%`,
                                    background: "#007c16",
                                  }}
                                ></div>
                              </div>
                            </Tippy>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="error-msg" style={{ margin: "10px auto" }}>
                  No pledges found
                </div>
              )}
            </>
          )}
        </>
      )}

      {step === "contact" && (
        <div className="contact-box">
          <h3 className="get-in-touch-heading">
            {t("OrganizationDetails.get_in_touch")}
          </h3>
          <div className="contact-info-box">
            {/* name */}
            <h6>{orgObj.name}</h6>
            {/* streetAddress and unit no */}
            <div className="p-row">
              <div>
                <Icon icon={basic_compass} size={16} />
              </div>
              <div className="p-row-text">
                {orgObj.streetAddress} {orgObj.unitNumber}
              </div>
            </div>
            {/* city province and postal code */}
            <div className="p-row">
              <div className="empty-div"></div>
              <div className="p-row-text">
                {orgObj.city} {orgObj.provinceState} {orgObj.postalZipCode}
              </div>
            </div>
            {/* country */}
            <div className="p-row">
              <div className="empty-div"></div>
              <div className="p-row-text">{orgObj.country}</div>
            </div>
            {/* phone */}
            <div className="p-row">
              <div>
                <Icon icon={basic_smartphone} size={16} />
              </div>
              <div className="p-row-text">{orgObj.phone}</div>
            </div>
            {/* email */}
            <div className="p-row" style={{ overflow: "hidden" }}>
              <div>
                <Icon icon={basic_mail} size={16} />
              </div>
              <div className="p-row-text">
                {orgObj.email ? (
                  <a href={`mailto:${orgObj.email}`}>{orgObj.email}</a>
                ) : (
                  <span>{t("Content.not_available")}</span>
                )}
              </div>
            </div>
            {/* website */}
            <div className="p-row" style={{ overflow: "hidden" }}>
              <div>
                <Icon icon={basic_world} size={16} />
              </div>
              <div className="p-row-text">
                {orgObj.website ? (
                  <a href={orgObj.website} target="blank">
                    {orgObj.website}
                  </a>
                ) : (
                  <span>{t("Content.not_available")}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <button
          type="button"
          className="go-back-to-campaign-selection-btn"
          onClick={handleGoBack}
        >
          {content}
        </button>
      </div>
    </>
  );
};

export default OrganizationPledges;
